import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { AccountService } from 'projects/authentication/_services/account.service';
import { SubscriptionService } from 'projects/authentication/_services/subscription.service';
import { Subject } from 'rxjs';
import { finalize, takeUntil } from 'rxjs/operators';
import { GlobalService } from 'src/app/_core/global.service';
import { AdsaptiveService } from 'src/app/_core/_services/adsaptive.service';
import { BehaviorService } from 'src/app/_core/_services/behavior.service';
import { EventsService } from 'src/app/_core/_services/events.service';
import { LangService } from 'src/app/_core/_services/lang.service';
import { LoginService } from 'src/app/_core/_services/login.service';
import { ThemeService } from 'src/app/_core/_services/theme.service';

declare var TPay: any;

@Component({
  selector: 'app-pop-up',
  templateUrl: './pop-up.component.html'
})
export class PopUpComponent implements OnInit {

  public loading_: boolean = false;
  public emailSended: boolean = false;

  public showingPopUp: any;
  public UserCredits$: number;
  public popSlideConfig: any;

  private lang$: string;
  public LightTheme$: boolean;

  public contentUrl;
  private infoEventTypes: any = {
    terms: ['TC_PAGE_ACCESS', 'TC_PAGE_LOADED'],
    regulations: ['HELP_PAGE_ACCESS', 'HELP_PAGE_LOADED'],
    policies: ['PRIVACY_POLICY_PAGE_ACCESS', 'PRIVACY_POLICY_PAGE_LOADED']
  }

  constructor(
    private sanitizer: DomSanitizer,
    public beh: BehaviorService,
    public global: GlobalService,
    private event: EventsService,
    private subsSvc: SubscriptionService,
    private loginSvc: LoginService,
    private langSvc: LangService,
    private accountSvc: AccountService,
    private themeSvc: ThemeService,
    private adsSvc: AdsaptiveService,
    private router: Router
  ) {
    this.themeSvc.lightTheme.subscribe(l => { this.LightTheme$ = l });
    this.beh.UserWallet.subscribe(w => { this.UserCredits$ = w.total || 0 });

    this.langSvc.lang.subscribe(l => {
      this.lang$ = l;
      this.popSlideConfig = {
        slidesToScroll: 1,
        slidesToShow: 1,
        infinite: false,
        autoplay: false,
        arrows: false,
        dots: true,
        rtl: !!(l == 'ar')
      }
    });

    this.beh.popup.subscribe(val => {
      setTimeout(() => {
        this.showingPopUp = val;
        if (this.showingPopUp?.pop == 'portal-info') {
          if (!!this.global.propConfs$.infoPages[this.lang$][this.showingPopUp.extraData]) {
            this.contentUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.global.propConfs$.infoPages[this.lang$][this.showingPopUp.extraData]);
            this.event.eventStart({ eventType: this.infoEventTypes[this.showingPopUp.extraData][0], eventCategory: 'ACCESS' });
          } else { this.beh.popup.next(null) }
        }
      }, 0);
    });
  }

  ngOnInit(): void { }

  private _subs = new Subject();
  ngOnDestroy() {
    this._subs.next();
    this._subs.complete();
    this.beh.paymentData.next(null);
  }

  public unsubscribe() {
    this.loading_ = true;
    this.subsSvc.doUnsubscribe({ productId: this.showingPopUp.extraData.productId }).subscribe(unsub => {
      if (unsub.responseCode == 'SUCCESS') {
        if (unsub.partnerResponse?.actionToPerform == 'TPAY_UNSUBSCRIBE') {
          localStorage.pu = btoa(JSON.stringify({ ...this.showingPopUp.extraData, sessKey: unsub.partnerResponse.additionalFields?.uparSessionKey }));

          let includeScript = document.createElement('script');
          includeScript.src = unsub.partnerResponse.additionalFields.script;
          document.head.appendChild(includeScript);

          let checkoutDictionary = {
            merchantTemplateKey: unsub.partnerResponse.additionalFields.merchantTemplateKey,
            msisdn: unsub.partnerResponse.additionalFields.msisdn,
            operatorCode: unsub.partnerResponse.additionalFields.operatorCode,
            language: unsub.partnerResponse.additionalFields.language,

            customerAccountNumber: unsub.partnerResponse.additionalFields.customerAccountNumber,
            subscriptionProductId: unsub.partnerResponse.additionalFields.subscriptionProductId,
            subscriptionProductPricingPlanId: unsub.partnerResponse.additionalFields.subscriptionProductPricingPlanId,
            redirectUrl: unsub.partnerResponse.additionalFields.redirectUrl,
            signature: unsub.partnerResponse.additionalFields.signature
          }

          setTimeout(() => { TPay.Unsubscription.Checkout(checkoutDictionary) }, 1000);

        } else {
          this.beh.eligibilityCallResp.next(null);
          this.loginSvc.loadUserSubscription();
          this.loginSvc.loadUserWallet();
          this.beh.popup.next(null);
        }

      } else {
        this.loading_ = false;
        this.beh.popup.next({ pop: 'error-generic' });
      }
    }, () => {
      this.loading_ = false;
      this.beh.popup.next({ pop: 'error-generic' });
    });
  }

  public resendValidationEmail() {
    this.loading_ = true;
    this.accountSvc.doIdentityConfirm({
      identifyType: 'EMAIL',
      identity: this.showingPopUp.extraData.mail
    }).subscribe(sended => {
      this.loading_ = false;
      sended.responseCode == 'SUCCESS' ? this.emailSended = true : this.beh.popup.next({ pop: 'error-generic' });
    }, () => {
      this.loading_ = false;
      this.beh.popup.next({ pop: 'error-generic' });
    });
  }

  public setAfterLoginRoute() {
    if (!!this.showingPopUp.extraData.routeTo) {
      let userSess = JSON.parse(sessionStorage.u || '{}');
      userSess.nr = this.showingPopUp.extraData.routeTo;
      sessionStorage.u = JSON.stringify(userSess);
    }

    if (!!this.showingPopUp.extraData.product) {
      let user = JSON.parse(localStorage.u || '{}');
      user.p = btoa(this.showingPopUp.extraData.product);
      localStorage.u = JSON.stringify(user);
    }
  }

  private subscribe() {
    this.loading_ = true;
    this.subsSvc.doSubscribe({ productId: this.showingPopUp.extraData.payment.productId, msisdn: this.showingPopUp.extraData.payment.normalizedMsisdn, additionalParameters: { uparSessionKey: this.showingPopUp.extraData.payment.sessKey, queryParam: location.search || sessionStorage.qP || undefined } }).pipe(takeUntil(this._subs)).subscribe(subscrip => {
      if (!!~['DISPLAY_SUCCESS_SUBSCRIPTION', 'DISPLAY_SUCCESS_PAYMENT'].indexOf(subscrip.partnerResponse?.actionToPerform)) {

        this.event.eventStart({ eventType: this.showingPopUp.extraData.payment.productType == 'SUBSCRIPTION' ? 'SUBSCRIPTION_SUCCESS' : 'PURCHASE_REQUESTED_SUCCESS', eventCategory: 'SUCCESS', responseData: JSON.stringify(subscrip), ammount: this.showingPopUp.extraData.payment.value, operatorId: this.showingPopUp.extraData.payment.operatorId, partnerName: this.showingPopUp.extraData.payment.operatorName, productId: this.showingPopUp.extraData.payment.productId, productName: this.showingPopUp.extraData.payment.price });

        let user = JSON.parse(localStorage.u || '{}');
        delete user.p;
        localStorage.u = JSON.stringify(user);

        !!user.tid && this.adsSvc.triggerPixel(atob(user.tid)).pipe(finalize(() => {
          user = JSON.parse(localStorage.u || '{}');
          delete user.tid;
          localStorage.u = JSON.stringify(user);
        })).toPromise();

        this.beh.eligibilityCallResp.next(null);
        this.loginSvc.loadUserSubscription();
        this.loginSvc.loadUserWallet();
        this.router.navigate(['wallet']);
        this.beh.popup.next({ pop: subscrip.partnerResponse.actionToPerform == 'DISPLAY_SUCCESS_SUBSCRIPTION' ? subscrip.partnerResponse.freePeriod ? 'subscription-processing' : 'success-subscription' : 'success-topup', extraData: { duraction: this.showingPopUp.extraData.payment.productDuration, charge: this.showingPopUp.extraData.payment.value } });
      } else if (!!~['ATT_PAYMENT_DAILY_LIMIT', 'ATT_PAYMENT_MONTHLY_LIMIT'].indexOf(subscrip.partnerResponse?.actionToPerform)) {
        this.beh.popup.next({ pop: 'custom', extraData: { title: 'popup.insufficientBalance', subtitle: `payment.${subscrip.partnerResponse.actionToPerform}`, sub_button_action_type: 'ACTION', sub_button_action: '', sub_button_text: 'popup.close' } });
        this.event.eventStart({ eventType: 'PAYMENT_ERROR_PAGE_ACCESS', eventCategory: 'ERROR', responseData: JSON.stringify(subscrip), ammount: this.showingPopUp.extraData.payment.value, operatorId: this.showingPopUp.extraData.payment.operatorId, partnerName: this.showingPopUp.extraData.payment.operatorName, productId: this.showingPopUp.extraData.payment.productId, productName: this.showingPopUp.extraData.payment.price });

        /*----- Block do limit -----*/
      } else if (!!~['DISPLAY_MAX_TOPUP_REACHED'].indexOf(subscrip.partnerResponse?.actionToPerform)) {

        this.beh.popup.next({
          pop: 'custom',
          extraData: {
            popup_image_url: 'https://webportals.cachefly.net/global/upar/assets/images/icons/ic_pup_6_error.svg',
            dark_popup_image_url: 'https://webportals.cachefly.net/global/upar/assets/images/icons/ic_pup_6_error_dark.svg',
            description: 'popup.reachedTopupDailyLimit',
            button_action_type: 'ACTION',
            button_action: '',
            button_text: 'global.continue'
          }
        });

        this.loading_ = false;
        this.router.navigate(['wallet', 'recharge']);
        this.event.eventStart({ eventType: 'PAYMENT_ERROR_PAGE_ACCESS', eventCategory: 'ERROR', responseData: JSON.stringify(subscrip), ammount: this.showingPopUp.extraData.payment.value, operatorId: this.showingPopUp.extraData.payment.operatorId, partnerName: this.showingPopUp.extraData.payment.operatorName, productId: this.showingPopUp.extraData.payment.productId, productName: this.showingPopUp.extraData.payment.price });

      } else if (!!~['DISPLAY_FAILED_SUB_DUE_TO_DATE'].indexOf(subscrip.partnerResponse?.actionToPerform)) {

        this.beh.popup.next({
          pop: 'custom',
          extraData: {
            popup_image_url: 'https://webportals.cachefly.net/global/upar/assets/images/icons/ic_pup_6_error.svg',
            dark_popup_image_url: 'https://webportals.cachefly.net/global/upar/assets/images/icons/ic_pup_6_error_dark.svg',
            description: 'popup.canceledSubscription',
            button_action_type: 'ACTION',
            button_action: '',
            button_text: 'global.continue'
          }
        });

        this.loading_ = false;
        this.router.navigate(['wallet', 'recharge']);
        this.event.eventStart({ eventType: 'PAYMENT_ERROR_PAGE_ACCESS', eventCategory: 'ERROR', responseData: JSON.stringify(subscrip), ammount: this.showingPopUp.extraData.payment.value, operatorId: this.showingPopUp.extraData.payment.operatorId, partnerName: this.showingPopUp.extraData.payment.operatorName, productId: this.showingPopUp.extraData.payment.productId, productName: this.showingPopUp.extraData.payment.price });
        /*----- Block do limit -----*/
      } else if (!!~['ALREADY_ACTIVE_MSISDN_OTHER_ACCOUNT'].indexOf(subscrip.partnerResponse?.actionToPerform)) {

        this.beh.popup.next({
          pop: 'custom',
          extraData: {
            popup_image_url: 'https://webportals.cachefly.net/global/upar/assets/images/icons/ic_pup_6_error.svg',
            dark_popup_image_url: 'https://webportals.cachefly.net/global/upar/assets/images/icons/ic_pup_6_error_dark.svg',
            description: 'popup.numberActiveInOtherAccount',
            button_action_type: 'ACTION',
            button_action: '',
            button_text: 'global.continue'
          }
        });

        this.loading_ = false;
        this.router.navigate(['wallet', 'recharge']);
        this.event.eventStart({ eventType: 'PAYMENT_ERROR_PAGE_ACCESS', eventCategory: 'ERROR', responseData: JSON.stringify(subscrip), ammount: this.showingPopUp.extraData.payment.value, operatorId: this.showingPopUp.extraData.payment.operatorId, partnerName: this.showingPopUp.extraData.payment.operatorName, productId: this.showingPopUp.extraData.payment.productId, productName: this.showingPopUp.extraData.payment.price });

      } else if (!!~['DISPLAY_GENERIC_ERROR'].indexOf(subscrip.partnerResponse?.actionToPerform)) {

        this.beh.popup.next({ pop: 'error-generic' });
        this.router.navigate(['wallet', 'recharge']);
        this.event.eventStart({ eventType: this.showingPopUp.extraData.payment.productType == 'SUBSCRIPTION' ? 'SUBSCRIPTION_ERROR' : 'PURCHASE_REQUESTED_ERROR', eventCategory: 'ERROR', responseData: JSON.stringify(subscrip), ammount: this.showingPopUp.extraData.payment.value, operatorId: this.showingPopUp.extraData.payment.operatorId, partnerName: this.showingPopUp.extraData.payment.operatorName, productId: this.showingPopUp.extraData.payment.productId, productName: this.showingPopUp.extraData.payment.price });
      
      } else {

        this.beh.popup.next({ pop: 'failed-payment' });
        this.router.navigate(['wallet', 'recharge']);
        this.event.eventStart({ eventType: 'PAYMENT_ERROR_PAGE_ACCESS', eventCategory: 'ERROR', responseData: JSON.stringify(subscrip), ammount: this.showingPopUp.extraData.payment.value, operatorId: this.showingPopUp.extraData.payment.operatorId, partnerName: this.showingPopUp.extraData.payment.operatorName, productId: this.showingPopUp.extraData.payment.productId, productName: this.showingPopUp.extraData.payment.price });
      
      }
      this.loading_ = false;
    }, noSub => {
      this.loading_ = false;
    });
  }

  public customAction(action) {
    switch (action) {
      case 'UNSUBSCRIBE':
        this.unsubscribe();
        break;

      case 'SUBSCRIBE':
        this.subscribe();
        break;

      default:
        this.beh.popup.next(null);
        break;
    }
  }

}